import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class TargetService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'Target/';
  // fetch all Target in the database
  allTarget(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getTarget(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getTargetByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postTarget(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteTarget(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateTarget(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
